import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const formData = useSelector((state) => state.form);

  const location = useLocation();
  const path = location.pathname;

  const fromCartEdit =
    (location.state && location.state.fromCartEdit) ||
    localStorage.getItem('fromCartEdit') === 'true';
  const fromWishlist = location.state && location.state.fromWishlist;

  if (fromCartEdit || fromWishlist) {
    return children;
  }

  const publicRoutes = [
    '/',
    '/about',
    '/contact',
    '/terms',
    '/privacy',
    '/refund',
    '/packages',
  ];
  const onlyAuthRoutes = ['/cart', '/wishlist', '/profile'];
  const emptyFormAllowedRoutes = [
    '/',
    '/about',
    '/contact',
    '/cart',
    '/wishlist',
    '/profile',
    '/return-gifts',
  ];
  const existingPackageRoutes = ['/packages'];

  const isPublicPackageDetails = /^\/packages\/[a-z0-9-]+$/.test(path);

  if (publicRoutes.includes(path) || isPublicPackageDetails) {
    return children;
  }

  if (!isAuthenticated && onlyAuthRoutes.includes(path)) {
    toast.dismiss();
    toast.error('Please login to continue');
    return <Navigate to='/' replace />;
  }

  const isFormEmpty =
    !formData.selectedType ||
    !formData.location ||
    !formData.eventType ||
    !formData.date;

  if (emptyFormAllowedRoutes.includes(path)) {
    return children;
  }

  if (isFormEmpty && !emptyFormAllowedRoutes.includes(path)) {
    toast.dismiss();
    toast.error('Please fill the details to continue');
    return <Navigate to='/' replace />;
  }

  if (!isFormEmpty) {
    if (
      formData.selectedType === 'existing' &&
      !path.startsWith('/venues') &&
      !path.startsWith('/packages')
    ) {
      return <Navigate to='/' replace />;
    }

    if (
      formData.selectedType === 'own' &&
      existingPackageRoutes.includes(path)
    ) {
      return <Navigate to='/' replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
